<template>
    <MainContent title="Estadísticas emails">
        <template v-slot:header>
            <DatosEstadisticas>
                <template v-slot:data>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <h4>Evento</h4>
                        <h5 class="text-primary">
                            {{ estadisticas.nombreEvento }}
                        </h5>
                    </li>

                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <h4>Autor</h4>
                        <h5 class="text-primary">
                            {{ estadisticas.autor }}
                        </h5>
                    </li>

                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <h4>Código</h4>
                        <h5 class="text-primary">
                            {{ estadisticas.codigo }}
                        </h5>
                    </li>

                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <h4>Recinto</h4>
                        <h5 class="text-primary">
                            {{ estadisticas.recinto }}
                        </h5>
                    </li>
                </template>

                <template v-slot:grafico>
                    <GChart
                        type="ColumnChart"
                        :data="chartData"
                        :options="chartOptions"
                    />
                </template>
            </DatosEstadisticas>
        </template>
        <template v-slot:content>
            <ContentEstadisticas>
                <template v-slot:cards>
                    <div class="col mx-2">
                        <AperturasUnicasCard
                            :n="estadisticas.aperturaUnica"
                        >
                            <template v-slot:router>
                                <router-link
                                    :to="{
                                        name: name,
                                        params: {
                                            'evento_id': id,
                                            listado_emails: 'abiertos',
                                        },
                                    }"
                                    class="mb-0 text-white font-weight-bold"
                                >
                                    Ver aperturas <i class="fas fa-external-link-alt"></i>
                                </router-link>
                            </template>
                        </AperturasUnicasCard>
                    </div>

                    <div class="col mx-2">
                        <ClicksUnicosCard
                            :n="estadisticas.clickadosUnicos"
                        >
                            <template v-slot:router>
                                <router-link
                                    :to="{
                                        name: name,
                                        params: {
                                            'evento_id': id,
                                            listado_emails: 'clickados',
                                        },
                                    }"
                                    class="mb-0 text-white font-weight-bold"
                                >
                                    Ver clicks <i class="fas fa-external-link-alt"></i>
                                </router-link>
                            </template>
                        </ClicksUnicosCard>
                    </div>

                    <div class="col mx-2">
                        <RetornosCard
                            :n="estadisticas.fallidosTotales"
                        >
                            <template v-slot:router>
                                <router-link
                                    :to="{
                                        name: name,
                                        params: {
                                            'evento_id': id,
                                            listado_emails: 'devueltos',
                                        },
                                    }"
                                    class="mb-0 text-white font-weight-bold"
                                >
                                    Ver retornos <i class="fas fa-external-link-alt"></i>
                                </router-link>
                            </template>
                        </RetornosCard>
                    </div>

                    <div class="col mx-2">
                        <MarcadosSpamCard
                            :n="estadisticas.marcadosSpam"
                        >
                            <template v-slot:router>
                                <router-link
                                    :to="{
                                        name: name,
                                        params: {
                                            'evento_id': id,
                                            listado_emails: 'spam',
                                        },
                                    }"
                                    class="mb-0 text-white font-weight-bold"
                                >
                                    Ver marcados como spam <i class="fas fa-external-link-alt"></i>
                                </router-link>
                            </template>
                        </MarcadosSpamCard>
                    </div>
                </template>

                <template v-slot:data>
                    <div class="col-6">
                        <ul class="list-unstyled">
                            <EmailsEnviados
                                :n="estadisticas.destinatarios"
                                :nEtiqueta="estadisticas.entregados + ' entregados'"
                                :etiqueta="true"
                            ></EmailsEnviados>
                            <Retornos
                                :n="estadisticas.fallidosTotales"
                                :nEtiqueta="estadisticas.fallidosPermanentes + ' permanentes'"
                                :etiqueta="true"
                            ></Retornos>
                            <MarcadosSpam
                                :n="estadisticas.marcadosSpam"
                                :etiqueta="false"
                            ></MarcadosSpam>
                        </ul>
                    </div>
                    <div class="col-6">
                        <ul class="list-unstyled">
                            <AperturasTotales
                                :n="estadisticas.nAperturasTotales"
                                :nEtiqueta="estadisticas.aperturaUnica + ' únicas'"
                                :etiqueta="true"
                            ></AperturasTotales>
                            <RatioApertura
                                :n="((estadisticas.aperturaUnica / estadisticas.destinatarios) * 100).toFixed(2) + ' %'"
                                :etiqueta="false"
                            ></RatioApertura>
                            <NumeroClicks
                                :n="estadisticas.nClicksTotales"
                                :nEtiqueta="estadisticas.clickadosUnicos + ' únicos'"
                                :etiqueta="true"
                            ></NumeroClicks>
                        </ul>
                    </div>
                </template>
            </ContentEstadisticas>
        </template>
    </MainContent>
</template>

<script>
import MainContent from "@/components/backend/components/MainContent";

import DatosEstadisticas from "@/components/backend/components/estadisticas/emails/DatosEstadisticas.vue";
import ContentEstadisticas from "@/components/backend/components/estadisticas/emails/ContentEstadisticas.vue";

import EmailsEnviados from "@/components/backend/components/estadisticas/emails/emails/EmailsEnviados.vue";
import Retornos from '@/components/backend/components/estadisticas/emails/emails/Retornos.vue';
import MarcadosSpam from '@/components/backend/components/estadisticas/emails/emails/MarcadosSpam.vue';
import AperturasTotales from "@/components/backend/components/estadisticas/emails/emails/AperturasTotales.vue";
import RatioApertura from "@/components/backend/components/estadisticas/emails/emails/RatioApertura.vue";
import NumeroClicks from "@/components/backend/components/estadisticas/emails/emails/NumeroClicks.vue";

import AperturasUnicasCard from '@/components/backend/components/estadisticas/emails/cards/AperturasUnicas.vue';
import ClicksUnicosCard from '@/components/backend/components/estadisticas/emails/cards/ClicksUnicos.vue';
import MarcadosSpamCard from '@/components/backend/components/estadisticas/emails/cards/MarcadosSpam.vue';
import RetornosCard from '@/components/backend/components/estadisticas/emails/cards/Retornos.vue';

export default {
    props: ['id'],
    data() {
        return {
            estadisticas: {},
            chartOptions: {
                legend: { position: "none" },
            },
            name: 'back.events.informe.emails.listado',
        }
    },
    methods: {
        getEstadisticasEventos() {
            const data = {
                filters: {},
                evento_id: this.id,
            };
            this.$store.dispatch(this.config.getVuexAlias("back.events.informe.emails"), data)
                .then(res => {
                    this.estadisticas = res.data.data;
                }).catch(e => {
                    console.log(e);
                });
        }
    },
    computed: {
        chartData() {
            return [
                ["Evento", "Cant", { role: "style" }],
                ["Enviados", this.estadisticas.destinatarios, "#70a328"],
                ["Entregados", this.estadisticas.entregados, "#20a2c1"],
                ["Abiertos", this.estadisticas.nAperturasTotales, "#007bff"],
                ["Clickados", this.estadisticas.nClicksTotales, "#28a745"],
                ["Fallidos", this.estadisticas.fallidosTotales, "#ffc107"],
                ["Marcados spam", this.estadisticas.marcadosSpam, "#dc3545"],
            ];
        }
    },
    created() {
        this.getEstadisticasEventos();
    },
    components: {
        MainContent,
        DatosEstadisticas,
        ContentEstadisticas,
        EmailsEnviados, AperturasTotales, MarcadosSpam, Retornos, RatioApertura, NumeroClicks,
        AperturasUnicasCard, ClicksUnicosCard, MarcadosSpamCard, RetornosCard,
    }
}
</script>